import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Auth from '@okta/okta-vue'
import { OktaAuth } from '@okta/okta-auth-js'
import { LoginCallback } from '@okta/okta-vue'
Vue.use(VueRouter)

const oktaAuth = new OktaAuth({
  issuer: process.env.VUE_APP_OKTA_ISSUER,
  clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
  redirectUri: process.env.VUE_APP_OKTA_REDIRECT_URI,
  scopes: ['openid', 'profile', 'email']
})
Vue.use(Auth, { oktaAuth })

const routes = [
  {
    path: '/',
    name: 'Loading',
    component: () => import(/* webpackChunkName: "Loading" */ '../views/Loading.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
  },
  {
    path: '/login/callback',
    component: LoginCallback
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue')
  },
  {
    path: '/bookings',
    name: 'Bookings',
    component: () => import(/* webpackChunkName: "Bookings" */ '../views/Bookings.vue')
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: () => import(/* webpackChunkName: "Accounts" */ '../views/Accounts.vue')
  },
  {
    path: '/menus',
    name: 'Menu Setting',
    component: () => import(/* webpackChunkName: "MenuSetting" */ '../views/MenuSetting.vue')
  },
  {
    path: '/queues',
    name: 'Queue Setting',
    component: () => import(/* webpackChunkName: "QueueSetting" */ '../views/QueueSetting.vue')
  },
  {
    path: '/booking_profiles',
    name: 'Booking Profiles',
    component: () => import(/* webpackChunkName: "BookingProfiles" */ '../views/BookingProfiles.vue')
  },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import(/* webpackChunkName: "Reports" */ '../views/Reports.vue')
  },
  {
    path: '/exchange_rate',
    name: 'Exchange Rate',
    component: () => import(/* webpackChunkName: "ExchangeRate" */ '../views/ExchangeRate.vue')
  },
  {
    path: '/sms_logs',
    name: 'SMS Logs',
    component: () => import(/* webpackChunkName: "SmsLogs" */ '../views/SmsLogs.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // avoid redirect to same page
  if (to === from) {
    return
  }

  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/', '/login', '/login/callback']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = store.state.auth.status
  if (authRequired && !loggedIn) {
    return next('/login')
  }

  // prevent logged in user access login page again
  if (publicPages.includes(to.path) && loggedIn) {
    return next('/dashboard')
  }

  next()
})

export default router
